
import dayjs from 'dayjs'
import spbkMixin from '~/mixin/or/spbkMixin'
import { ugMixin } from '~/mixin/ug/ugMixin'
import { commonfunc } from '~/mixin/common'
import { isShowTotalSelling } from '~/config/options'

export default {
  name: 'ProdUnit',
  components: {},
  mixins: [commonfunc, spbkMixin, ugMixin],
  props: {
    item: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    idx: { // 상품 index
      type: Number
    },
    unitType: { // 상품 type
      type: String,
      default: 'general'
    },
    listGroup: { // 그룹 상품리스트 사용 여부
      type: Boolean,
      default: false
    },
    review: { // 리뷰 유닛
      type: Boolean,
      default: false
    },
    quantity: { // 수량 노출
      type: Boolean,
      default: false
    },
    close: { // 닫기 버튼 기능
      type: Boolean,
      default: false
    },
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    radio: { // 라디오 선택
      type: Boolean,
      default: false
    },
    contwriter: { // 사용자 등록 상품 type
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    typeList: { // 리스트 타입
      type: Boolean,
      default: false
    },
    order: { // (메뉴)주문에서만 사용 - 가격 우측 정렬 등
      type: Boolean,
      default: false
    },
    long: { // long type veideo
      type: Boolean,
      default: false
    },
    scrId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowTotalSelling,
      num: 0, // 수량
      swiperOpt: { // 묶음상품 swiper options
        slidesPerView: 4,
        loop: false,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정

      },
      mbMngNo: this.$store.getters['session/getMbMngNo'],
      newSwiperOpt: { // 신상품 swiper options
        slidesPerView: 3,
        loop: false,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-progress',
          type: 'progressbar'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planBoxSwiperOpt: { // 기획전 (신상품) 박스형 swiper options
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planSwiperOpt: { // 기획전 (신상품) 리스트형 swiper options
        slidesPerView: 2,
        loop: false,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
    }
  },
  computed: {
    reviewNum () { // 23.08.25 수정
      if (typeof this.item.reviewNum === 'number') {
        if (this.item.reviewNum > 9999 && this.item.reviewNum <= 99999) {
          return '9.9+ 천'
        } else if (this.item.reviewNum > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.reviewNum).toLocaleString('ko-KR')
        }
      } else if (this.item.reviewNum === 'string') {
        if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.reviewNum.replace(/[^0-9]/g, '')) <= 99999) {
          return '9,9+ 천'
        } else if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 99999) {
          return '99,9+ 만'
        }
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    total () { // 23.08.25 수정
      if (typeof this.item.total === 'number') {
        if (this.item.total > 9999 && this.item.total <= 99999) {
          return '9.9+ 천'
        } else if (this.item.total > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.total).toLocaleString('ko-KR')
        }
      } else if (typeof this.item.total === 'string') {
        if (Number(this.item.total.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.total.replace(/[^0-9]/g, '')) <= 99999) {
          return '9.9+ 천'
        } else if (Number(this.item.total.replace(/[^0-9]/g, '')) > 99999) {
          return '99.9+ 만'
        }
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    prodPrice () {
      if (typeof this.item.pdPrc === 'number') {
        return Number(this.item.pdPrc).toLocaleString('ko-KR')
      } else {
        return Number(this.item.pdPrc.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    rankFlag () {
      if (typeof this.item.ranking.variance === 'number') {
        if (this.item.ranking.variance === 0) { // 변동없음
          return ''
        } else { // up & down
          return Math.abs(this.item.ranking.variance)
        }
      } else {
        return 'new'
      }
    },
    setSleStDtm () {
      let sleStDtm = ''

      if (this.isNotEmpty(this.item.sleStDt)) {
        sleStDtm = this.item.sleStDt
      } else if (this.isNotEmpty(this.item.SLE_ST_DTM)) {
        sleStDtm = this.item.SLE_ST_DTM
      }

      return sleStDtm
    },
    ntcnDate () {
      const opTime = dayjs(this.setSleStDtm).format('YYYY-MM-DD HH:mm:ss')
      let opRunTime = ''
      let amPm = ''

      if (opTime !== '') {
        const week = ['일', '월', '화', '수', '목', '금', '토']
        const month = new Date(opTime).getMonth() + 1
        const date = new Date(opTime).getDate()
        let time = new Date(opTime).getHours()
        const dayOfWeek = week[new Date(opTime).getDay()]
        if (time < 12) {
          amPm = '오전'
        } else {
          amPm = '오후'
          if (time !== 12) {
            time -= 12
          }
        }

        const now = new Date()
        const timeGap = new Date(opTime) - now

        if (timeGap > 24 * 60 * 60 * 1000) { // 24시간
          opRunTime = `${month}/${date}(${dayOfWeek})`
        } else {
          opRunTime = `${amPm} ${time}시`
        }
      }
      return opRunTime
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (document.querySelectorAll('.goods-list.ugc.masonry').length > 0) {
      this.unitHeight()
    }
  },
  unmounted () {
  },
  methods: {
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    toggleChk (event) {
      this.$emit('toggle-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    alarmChk (event) {
      this.$emit('alarm-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    newAlarmChk (event) {
      this.$emit('alarm-chk', {
        prodId: event.prodId,
        id: event.id,
        checked: event.chk
      })
    },
    unitHeight () {
      document.querySelectorAll('.goods-list.ugc.masonry > .goods-unit').forEach((el) => {
        // console.log(el.clientHeight)
        el.style.cssText = 'grid-row-end: span ' + (el.clientHeight + 0)
      })
    },
    prodClose (event) {
      this.$emit('prod-close', event)
    },
    updLike (ctenId, isLike, ev) {
      const act = {
        ctenId,
        lgnMbMngNo: this.$store.getters['session/getMbMngNo'],
        avtTy: 'L' /* 좋아요L, 스크랩(찜)S, 신고R */
      }
      if (isLike === 'Y') {
        isLike = 'N'
        act.likeActTy = 'M' // 좋아요 취소
      } else {
        isLike = 'Y'
        act.likeActTy = 'P' // 좋아요
      }

      if (this.lgnMbMngNo === '' || this.lgnMbMngNo === 'undefined') {
        this.$alert('로그인을 진행해주세요.')
        return false
      } else {
        console.log('act=', act)
        console.log(ev)

        this.$AxiosBuilder
          .data(act)
          .build()
          .post('/ug/common/updCtenLike')
          .then((res) => {
            if ((!res.data.data.success && res.data.data.returnCode === '-1')) {
              this.$confirm(this.$t('UG.REG_PROFILE_FOR_LIKE'), { center: true, dangerouslyUseHTMLString: true }).then(() => {
                this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: this.$route.fullPath } })
              }).catch(() => {
                return false
              })
            } else if (!res.data.success) {
              return false
            } else if (act.avtTy === 'L') {
              if (act.likeActTy === 'P') {
                console.log(ev)
              } else {
                console.log(ev)
              }
            }
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    callAddSpbk (prodInfo) { // 장바구니 담기 클릭 이벤트
      const mbMnbNo = this.$store.getters['session/getMbMngNo']
      if (mbMnbNo === undefined) {
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return false
      }

      if (prodInfo.optPdYn === 'Y') { // 상품이 여러옵션인경우
        this.$confirm(this.$t('PD.CART_OPTION'), '', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: prodInfo.pdNo } })
        }).catch(() => {

        })
      } else { // 상품이 단품옵션인 경우,
        const prd = {
          pdNo: prodInfo.pdNo, // 상품번호
          onldPdNo: prodInfo.onldPdNo, // 온라인전용상품번호,
          spbkQy: 1, // 수량. 1로 고정
          lsUpdrId: this.scrId,
          mbMngNo: this.mbMngNo,
          exhPdNm: prodInfo.exhPdNm ? prodInfo.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
          price: prodInfo.price ? prodInfo.price : prodInfo.pdPrc ? prodInfo.pdPrc : '', // GTM 작업을 위한 파라미터 추가
          onlSclCd: prodInfo.onlSclCd ? prodInfo.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
          brndNm: prodInfo.brndNm ? prodInfo.brndNm : '', // GTM 작업을 위한 파라미터 추가
          ...prodInfo
        }
        this.clickAddSpbkBtn(prd)
      }
    }
  }
}
